import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReviews } from '../../../redux/slices/reviewsSlice';
import { Box, Typography, Avatar, Paper } from "@mui/material";
import { styled } from "@mui/system";
import Slider from "react-slick";
import Statisticsbg from "./../../../assets/images/bgsection/Statisticsbg.png";
import Testimonial1 from "./../../../assets/images/Testimonial/Testimonial1.png";
import { FaQuoteRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loading from './../../../components/UI/Loading/Loading';
// import Error from './../../../components/UI/Error';
// Styled Component for the Card Container
const TestimonialCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(3),
  borderRadius: "12px",
  position: "relative",
  margin: "0 auto",
  background: "#fff",
  overflow: "visible",
  textAlign: "right",
  maxWidth: "800px",
  minWidth: "300px",  // Minimum width for smaller screens
  minHeight: "100px", // Minimum height to ensure consistent card size
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    maxWidth: "100%",
    minWidth: "200px",  // Adjust for smaller screens
    minHeight: "180px", // Adjust height for smaller screens
  },
}));

const AvatarContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "-43px",
  zIndex: 10,
  borderRadius: "50%",
  padding: "4px",
}));

// Custom Arrow Styles
const ArrowButton = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "40px",
  height: "40px",
  backgroundColor: "#fff",
  borderRadius: "50%",
  cursor: "pointer",
  color: "#C49A6C",
  transition: "all 0.3s ease",
  position: "absolute",
  zIndex: 10,
  "&:hover": {
    backgroundColor: "#A87C50",
  },
  [theme.breakpoints.down("md")]: {
    width: "30px",
    height: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "30px",
    height: "30px",
  },
}));

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowButton
      style={{
        top: "50%",
        transform: "translateY(-50%)",
      }}
      sx={{
        right: {
          xs: "-15px",
          sm: "-15px",
          md: "30px",
          lg: "50px",
          xl: "120px",
        },
      }}
      onClick={onClick}
    >
      <FaChevronRight size={20} />
    </ArrowButton>
  );
};

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowButton
      style={{
        top: "50%",
        transform: "translateY(-50%)",
      }}
      sx={{
        left: {
          xs: "-15px",
          sm: "-15px",
          md: "30px",
          lg: "50px",
          xl: "120px",
        },
      }}
      onClick={onClick}
    >
      <FaChevronLeft size={20} />
    </ArrowButton>
  );
};

const Testimonial = ({ t, direction,language }) => {
  const dispatch = useDispatch();
  const { reviews, status } = useSelector((state) => state.reviews);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchReviews(language));
    }
  }, [status, dispatch]);
 
  const sliderSettings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 4000,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: `url(${Statisticsbg}) 50% 10% / cover fixed no-repeat, #000000`,
        padding: "40px 20px",
        [theme => theme.breakpoints.up("lg")]: {
          padding: "40px 40px",
        },
      }}
    >
     {status === 'loading' ? (
    <Loading />
  // ) : status === 'failed' ? (
  //   <Error message={error} />
  ) : (
   <>
      <Box data-aos="fade-down">
        {/* Section Title */}
        <Typography
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            fontWeight: "bold",
            color: "#fff",
            marginBottom: "20px",
            fontSize: "32px",
            "&::before, &::after": {
              content: '""',
              width: { xs: "50px", sm: "80px", lg: "134px" },
              borderBottom: "2px solid #fff",
              margin: "0 10px",
            },
          }}
        >
          {t.testimonialTitle}
        </Typography>

        <Typography
          sx={{
            textAlign: "center",
            color: "#ddd",
            marginBottom: "20px",
            fontSize: { xs: "12px", sm: "14px", lg: "18px" },
          }}
        >
          {t.testimonialSubtitle}
        </Typography>
      </Box>
      <Box data-aos="zoom-in">
      {status === 'succeeded' && (
        <>
        {/* Testimonials Slider */}
        <Slider {...sliderSettings}>
        {reviews.map((review, index) => (

            <Box
            key={index}
              sx={{
                position: "relative",
                padding: "40px",
                flexDirection: direction === "ltr" ? "row-reverse" : "row",
              }}
            >
              <TestimonialCard elevation={3} sx={{ textAlign: direction === "ltr" ? "left" : "right", }}>
                {/* Avatar */}
                <AvatarContainer
                  sx={{
                    right: direction === "ltr" ? "10px" : "unset",
                    left: direction === "ltr" ? "unset" : "10px",
                  }}
                >
                  <Avatar
                    alt="Customer"
                    // src={review.customeerImage || ''}
                    src={review.customeerImage?.includes("http") ? review.customeerImage : ""}
                     loading="lazy"
                    sx={{
                      width: { xs: 60, sm: 70, lg: 80 },
                      height: { xs: 60, sm: 70, lg: 80 },
                    }}
                  >
                          {/* Display first 2 characters if not a valid image, fallback to "NA" */}
                          {(!review.customeerImage?.includes("http") && review.customeerImage?.slice(0, 2).toUpperCase()) || "NA"}
                        </Avatar>

                </AvatarContainer>

                {/* Testimonial Content */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginLeft: direction === "ltr" ? "0px" :{md: "60px",xs:"0px"},
                    marginRight: direction === "ltr" ?{md: "60px",xs:"0px"}: "0px",
                    width: "100%",
                    flexDirection: direction === "ltr" ? "row-reverse" : "row",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "14px", lg: "16px" },
                      color: "#555",
                      lineHeight: "1.6",
                      flexGrow: 1,
                    }}
                  >
                   {review.reviewDescription}
                  </Typography>

                  {/* Quote Icon */}
                  <Box
                    component="span"
                    sx={{
                      fontSize: { xs: "18px", sm: "20px", lg: "24px" },
                      color: "#C49A6C",
                      marginLeft: direction === "ltr" ? "0px" : "12px",
                      marginRight: direction === "ltr" ? "12px" : "0px",
                    }}
                  >
                    <FaQuoteRight />
                  </Box>
                </Box>
              </TestimonialCard>
            </Box>
          ))}
        </Slider>
        </>
         )}
      </Box>
      </>
  )}
    </Box>
   
  );
};

export default Testimonial;
